import { useContext } from "react";
import { Context_UI } from "../../Contexts/Context_UI";
import { useNavigate } from 'react-router-dom';
import UI_Input_Text from "./UI_Input_Text";
import UI_ChipGroup from "./UI_ChipGroup";
export default function UI_Card({
    children,
    Shape,
    Icon,
    Text,
    Figure,
    Destination,
    Type,
    onClick,
    Subtype,
    Color,
    LoadingScreen,
    id,
    onChange,
    onBlur,
    autoFocus,
    onFocus,
    disabled,
    onSubmit,
    onInput,
    onKeyDown,
    Input_Type }) {
    const UI = useContext(Context_UI);
    const Navigate = useNavigate();
    const handleClick = () => {
        if (onClick) {
            onClick();
        }
        else if (Destination) {
            if (!LoadingScreen) {
                Navigate(`/${Destination}`);
            } else {
                UI.Page_ChangePage(`/${Destination}`, "Loading");
            }

        }
    };
    return (
        <>
            {(Shape == "Square" || Shape == "Rectangle") && Type != "Panel_Info" ?
                <button className='Card' Shape={Shape} Type={Type} Subtype={Subtype} Color={Color} onClick={handleClick} id={id}>
                    {Icon ?
                        <img className='Card_Icon' src={Icon} draggable='false' loading='lazy' alt='' />
                        :
                        ""
                    }
                    <h1 className='Card_Figure'>
                        {Figure}
                    </h1>
                    <h2 className='Card_Text'>
                        {Text}
                    </h2>
                </button>
                :
                Type == "Panel_Info" ?
                    <div className='AM_Details_Data' id={id}>
                        <p className='General_Paragraph'>
                            {Text}
                        </p>
                        <h3 className='General_Paragraph'>
                            {Figure}
                        </h3>
                    </div>
                    :
                    Type == "Panel_Info_Inverted" ?
                        <div className='AM_Details_Data' id={id}>
                            <h3 className='General_Paragraph'>
                                {Figure}
                            </h3>
                            <p className='General_Paragraph'>
                                {Text}
                            </p>
                        </div>
                        :
                        Type == "Panel_Info_Image" ?
                            <div className='AM_Details_Data' id={id} >
                                <p className='General_Paragraph'>
                                    {Text}
                                </p>
                                <div style={{ height: "250px" }}>
                                    <img src={Figure} style={{ width: "100%", height: "100%", objectFit: "contain" }} draggable="false" loading="lazy" />
                                </div>
                            </div>
                            :
                            Type == "Panel_Info_Editable" ?
                                <div className='AM_Details_Data' id={id}>
                                    <p className='General_Paragraph'>
                                        {Text}
                                    </p>
                                    <UI_Input_Text
                                        Input_Type={Input_Type}
                                        Input_Placeholder={Text}
                                        Value={Figure}
                                        // Value_Set_Enable={true}
                                        id={`${id}_Input`}
                                        onSubmit={onSubmit}
                                        onKeyDown={onKeyDown}
                                        onInput={onInput}
                                        onChange={onChange}
                                        onClick={onClick}
                                        onFocus={onFocus}
                                        onBlur={onBlur}
                                        autoFocus={autoFocus}
                                        disabled={disabled} />
                                </div>
                                :
                                Type == "Schedule_List" ?
                                    <button className="Card_List_Grid_Item" onClick={handleClick} Subtype={Subtype}>
                                        <div class="Card_List_Grid_Item_Pill"></div>
                                        <h3 className="Card_List_Grid_Item_Title">
                                            {Figure.Title}
                                        </h3>
                                        <p className="Card_List_Grid_Item_Figure">
                                            {Figure.Main}
                                        </p>
                                        <div className="Card_List_Grid_Item_Chips">
                                            <UI_ChipGroup Items={Figure.Chip} />
                                        </div>
                                        

                                    </button>
                                    :
                                    ""
            }
            {Type === "KeyValue" ?
                <div className="Card Card_KeyValue" Color={Color ? Color : undefined}>
                    <p className="Card_KeyValue_Key">
                        {Figure.Key}
                    </p>
                    <div className="Card_KeyValue_Value">
                        {Figure.Value}
                    </div>
                </div>
                :
                ""
            }

        </>
    )
}

